import { css } from '@/styled-system/css';

export const progressStepperCurrentLabelStyles = css.raw({
  'display': 'none',
  'paddingInlineStart': 'calc((var(--c11n-step-width) / 2) - {sizes.indicator.xs})',

  '&&': {
    textAlign: 'left',
  },
});
